/* ============================================
   PRODUCT CUSTOMIZER PREVIEW JS
   Handles: variants, price, live mockup preview,
   dimension labels, thickness depth,
   cart via theme's cart-container.add(),
   cart image injection on kt.cart.reloaded
   ============================================ */

(function () {
  'use strict';

  const STORAGE_KEY = 'pe_customization_';
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => (ctx || document).querySelectorAll(sel);

  let variants = [];
  let productOptions = [];
  let selectedOptions = {};
  let currentVariant = null;
  let productHandle = '';
  let previousSize = null;
  let savedOrientation = null; // 'portrait' or 'landscape' from photo editor

  // Thickness -> depth level (1, 2, 3)
  const THICKNESS_DEPTH = {
    '3mm': '1', '5mm': '2', '8mm': '3',
  };

  // Thickness -> bar height (visual thickness increases vertically)
  const THICKNESS_BAR_HEIGHT = {
    '3mm': 4, '5mm': 8, '8mm': 14,
  };

  function init() {
    const section = $('.pcp-section');
    if (!section) return;

    productHandle = section.dataset.productHandle || '';

    const variantsEl = $('#pcp-variants-json');
    const optionsEl = $('#pcp-product-options-json');

    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}
    }
    if (optionsEl) {
      try { productOptions = JSON.parse(optionsEl.textContent); } catch (e) {}
    }

    $$('.pcp-option__btn--active').forEach((btn) => {
      selectedOptions[parseInt(btn.dataset.optionIndex, 10)] = btn.dataset.optionValue;
      // If the active option button is the Shape, sync the preview frame class.
      const optName = (btn.dataset.optionName || '').trim();
      const shapeName = section.dataset.shapeOptionName || 'Shape';
      if (optName && optName.toLowerCase() === shapeName.toLowerCase()) {
        applyFrameType(btn.dataset.optionValue);
      }
    });

    currentVariant = findVariant();
    previousSize = getSizeValue();

    bindOptionButtons();
    bindTabs();
    bindEditButtons();
    bindFormSubmit();
    loadCustomization(); // sets savedOrientation BEFORE updateMockupOverlay
    updateMockupOverlay();
    listenCartReload();

    /* Listen for photo-editor's save event — refresh the customizer preview
       immediately so the user sees their new photo in-place, no page reload. */
    document.addEventListener('pe:saved', function(e) {
      if (!e.detail || e.detail.handle !== productHandle) return;
      loadCustomization();
      updateMockupOverlay();
      populatePersonalizationInputs(e.detail.personalization || {});
    });
    // Hydrate personalization inputs from localStorage on mount so refresh preserves values
    hydratePersonalizationFromStorage();
  }

  /* Populate hidden `properties[<label>]` inputs from photo-editor's personalization values.
     Matching happens by data-personalization-key — the metaobject's `key` field. */
  function populatePersonalizationInputs(values) {
    document.querySelectorAll('.pcp-pers-input').forEach((input) => {
      const key = input.dataset.personalizationKey;
      if (!key) return;
      input.value = (values && values[key] != null) ? String(values[key]) : '';
    });
  }
  function hydratePersonalizationFromStorage() {
    try {
      const saved = localStorage.getItem('pe_customization_' + productHandle);
      if (!saved) return;
      const data = JSON.parse(saved);
      if (data && data.personalization) populatePersonalizationInputs(data.personalization);
    } catch (e) {}
  }

  // ---- OPTION BUTTONS ----
  function bindOptionButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.pcp-option__btn');
      if (!btn) return;

      const idx = parseInt(btn.dataset.optionIndex, 10);
      const value = btn.dataset.optionValue;

      const parent = btn.closest('.pcp-option__buttons');
      if (parent) {
        parent.querySelectorAll('.pcp-option__btn').forEach((b) => b.classList.remove('pcp-option__btn--active'));
      }
      btn.classList.add('pcp-option__btn--active');

      const oldSize = getSizeValue();
      selectedOptions[idx] = value;
      currentVariant = findVariant();

      // If this option is the configured Shape/Frame option, swap the
      // preview frame class so the user sees the new shape immediately.
      const optName = (btn.dataset.optionName || '').trim();
      const section = btn.closest('.pcp-section');
      const shapeName = section ? (section.dataset.shapeOptionName || 'Shape') : 'Shape';
      if (optName && optName.toLowerCase() === shapeName.toLowerCase()) {
        applyFrameType(value);
      }

      if (currentVariant) {
        updateVariantId(currentVariant.id);
        updatePrice(currentVariant);
        updateStock(currentVariant);
        updateAvailability(currentVariant);
        updateURL(currentVariant.id);

        const newSize = getSizeValue();
        if (oldSize && newSize && oldSize !== newSize) {
          showSizeComparison(oldSize, newSize);
        }
        previousSize = newSize;

        updateMockupOverlay();
      }
    });
  }

  /* Normalize a frame-shape value to the css class suffix and apply it to
     the preview frame element. e.g. "Round Frame" → "round-frame". */
  function applyFrameType(value) {
    const frame = document.getElementById('pcp-frame-display');
    if (!frame) return;
    const slug = String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    if (!slug) return;
    // Strip any existing pcp-frame--* modifier
    frame.className = frame.className.replace(/\bpcp-frame--\S+/g, '').trim();
    frame.classList.add('pcp-frame--' + slug);
    frame.setAttribute('data-frame-type', slug);
  }

  function findVariant() {
    return variants.find((v) =>
      productOptions.every((_, idx) => v.options[idx] === selectedOptions[idx])
    );
  }

  function updateVariantId(id) {
    const input = $('#pcp-variant-id');
    if (input) input.value = id;
  }

  function updatePrice(variant) {
    const currentEl = $('#pcp-price-current');
    const compareEl = $('#pcp-price-compare');
    const badgeEl = $('#pcp-price-badge');

    if (currentEl) currentEl.textContent = formatMoney(variant.price);

    const hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (compareEl) {
      compareEl.textContent = hasDiscount ? formatMoney(variant.compare_at_price) : '';
      compareEl.style.display = hasDiscount ? '' : 'none';
    }

    if (badgeEl) {
      if (hasDiscount) {
        const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        badgeEl.textContent = pct + '% OFF';
        badgeEl.style.display = '';
      } else {
        badgeEl.style.display = 'none';
      }
    }
  }

  function updateStock(variant) {
    const stockEl = $('#pcp-stock');
    if (!stockEl) return;
    if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) {
      stockEl.innerHTML = '<span class="pcp-stock__low">Only ' + variant.inventory_quantity + " Acrylic's left!</span>";
    } else {
      stockEl.innerHTML = '';
    }
  }

  function updateAvailability(variant) {
    const buyBtn = $('#pcp-buy-now');
    const atcBtn = $('#pcp-add-to-cart');
    if (buyBtn) buyBtn.disabled = !variant.available;
    if (atcBtn) atcBtn.disabled = !variant.available;
  }

  function updateURL(variantId) {
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }

  // ---- RESOLVE DIMENSIONS (respect editor orientation) ----
  // Size options are always "WxH" e.g. "12x9", "16x12"
  // If editor orientation = portrait and W > H, swap to make it portrait
  // If editor orientation = landscape and H > W, swap to make it landscape
  function resolveWH(sizeVal) {
    if (!sizeVal || !sizeVal.includes('x')) return null;
    const parts = sizeVal.split('x');
    let w = parseFloat(parts[0]);
    let h = parseFloat(parts[1]);

    if (savedOrientation === 'portrait' && w > h) {
      var tmp = w; w = h; h = tmp;
    } else if (savedOrientation === 'landscape' && h > w) {
      var tmp2 = w; w = h; h = tmp2;
    }

    return { w: w, h: h };
  }

  // ---- DYNAMIC FRAME SCALE (from schema settings, integer %) ----
  function calculateScale(sizeVal) {
    const section = $('.pcp-section');
    // Schema values are integer percentages (e.g. 22 means 0.22)
    const minScale = parseFloat(section?.dataset.frameMinScale || 22) / 100;
    const maxScale = parseFloat(section?.dataset.frameMaxScale || 65) / 100;

    // Collect all size options from buttons
    const allSizes = [];
    $$('.pcp-option__btn').forEach((btn) => {
      const val = btn.dataset.optionValue;
      if (val && val.match(/^\d+x\d+$/)) {
        const p = val.split('x');
        allSizes.push({ val: val, area: parseFloat(p[0]) * parseFloat(p[1]) });
      }
    });

    if (allSizes.length === 0) return 0.35;

    const uniqueAreas = [...new Set(allSizes.map((s) => s.area))].sort((a, b) => a - b);
    const minArea = uniqueAreas[0];
    const maxArea = uniqueAreas[uniqueAreas.length - 1];

    const parts = sizeVal.split('x');
    const currentArea = parseFloat(parts[0]) * parseFloat(parts[1]);

    if (maxArea === minArea) return (minScale + maxScale) / 2;

    const t = (currentArea - minArea) / (maxArea - minArea);
    return minScale + t * (maxScale - minScale);
  }

  // ---- MOCKUP OVERLAY (dimensions, depth, frame sizing) ----
  function updateMockupOverlay() {
    const sizeVal = getSizeValue();
    const thicknessVal = getThicknessValue();
    const overlay = $('#pcp-frame-overlay');
    const frame = $('#pcp-frame-display');
    const mockupWrap = $('#pcp-mockup-wrap');
    if (!overlay || !mockupWrap) return;

    const mockupW = mockupWrap.offsetWidth;
    const mockupH = mockupWrap.offsetHeight;

    let scale = 0.35;
    if (sizeVal) scale = calculateScale(sizeVal);

    let frameW, frameH;
    const dims = resolveWH(sizeVal);
    if (dims) {
      const ratio = dims.w / dims.h;
      frameH = mockupH * scale;
      frameW = frameH * ratio;
      if (frameW > mockupW * 0.45) {
        frameW = mockupW * 0.45;
        frameH = frameW / ratio;
      }
    } else {
      frameW = mockupW * scale;
      frameH = mockupH * scale;
    }

    overlay.style.width = Math.round(frameW) + 'px';

    if (frame) {
      frame.style.height = Math.round(frameH) + 'px';
    }

    if (frame && thicknessVal) {
      const depth = THICKNESS_DEPTH[thicknessVal] || '1';
      frame.setAttribute('data-depth', depth);
    }

    updateDimensionLabels(sizeVal);
    updateThicknessBar(thicknessVal);

    const img = $('#pcp-customized-image');
    if (img && img.style.display !== 'none') {
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
    }

    const emptyState = $('#pcp-empty-state');
    if (emptyState && (!img || img.style.display === 'none')) {
      emptyState.style.width = '100%';
      emptyState.style.height = '100%';
    }
  }

  function updateDimensionLabels(sizeVal) {
    const wText = $('#pcp-dim-w-text');
    const hText = $('#pcp-dim-h-text');
    const dims = resolveWH(sizeVal);
    if (!dims) return;

    const cmW = (dims.w * 2.54).toFixed(2);
    const cmH = (dims.h * 2.54).toFixed(2);

    if (wText) wText.textContent = dims.w + ' Inches (' + cmW + ' cm)';
    if (hText) hText.textContent = dims.h + ' Inches (' + cmH + ' cm)';
  }

  function updateThicknessBar(thicknessVal) {
    const label = $('#pcp-thickness-label');
    const line = $('#pcp-thickness-line');
    if (!thicknessVal) return;

    if (label) label.textContent = 'Thickness: ' + thicknessVal;
    if (line) {
      line.style.width = '100%';
      const barH = THICKNESS_BAR_HEIGHT[thicknessVal] || 4;
      line.style.height = barH + 'px';
    }
  }

  function getSizeValue() {
    for (const idx in selectedOptions) {
      if (selectedOptions[idx]?.match(/^\d+x\d+$/)) return selectedOptions[idx];
    }
    return null;
  }

  function getThicknessValue() {
    for (const idx in selectedOptions) {
      if (selectedOptions[idx]?.match(/^\d+mm$/)) return selectedOptions[idx];
    }
    return null;
  }

  // ---- LOAD CUSTOMIZATION FROM LOCALSTORAGE ----
  function loadCustomization() {
    if (!productHandle) return;
    try {
      const saved = localStorage.getItem(STORAGE_KEY + productHandle);
      if (!saved) return;
      const data = JSON.parse(saved);

      if (data.thumbnail) {
        const img = $('#pcp-customized-image');
        const emptyState = $('#pcp-empty-state');
        const editBtn = $('#pcp-edit-overlay-btn');
        const slotGrid = $('#pcp-slot-grid');
        const frame = $('#pcp-frame-display');
        const frameSlots = parseInt((frame && frame.getAttribute('data-photo-slots')) || '1', 10) || 1;

        // Multi-photo product: ALWAYS paint the grid. Use per-slot thumbnails
        // when available; otherwise repeat the single thumbnail across all slots
        // so the customer sees a proper N-photo layout (never a full-bleed image
        // taking over the collage).
        if (slotGrid && frameSlots > 1) {
          const slotEls = slotGrid.querySelectorAll('.pcp-frame__slot');
          const slotArr = Array.isArray(data.slotThumbnails) ? data.slotThumbnails : [];
          slotEls.forEach((slot, idx) => {
            const src = slotArr[idx] || slotArr.find(Boolean) || data.thumbnail;
            const im = slot.querySelector('img');
            if (im && src) im.src = src;
          });
          slotGrid.style.display = '';
          if (img) img.style.display = 'none';
        } else {
          if (img) { img.src = data.thumbnail; img.style.display = 'block'; }
          if (slotGrid) slotGrid.style.display = 'none';
        }
        if (emptyState) emptyState.style.display = 'none';
        if (editBtn) editBtn.style.display = '';
      }

      if (data.frameType) {
        const frame = $('#pcp-frame-display');
        if (frame) {
          frame.className = 'pcp-frame pcp-frame--' + data.frameType;
          frame.setAttribute('data-frame-type', data.frameType);
        }
      }

      if (data.borderColor) {
        const frame = $('#pcp-frame-display');
        if (frame) frame.style.borderColor = data.borderColor;
      }

      // Read orientation from photo editor
      if (data.orientation) {
        savedOrientation = data.orientation;
      }

      const handleInput = $('#pcp-customization-handle');
      const thumbInput = $('#pcp-customization-thumb');
      if (handleInput) handleInput.value = productHandle;
      if (thumbInput && data.thumbnail) thumbInput.value = 'customized';
    } catch (err) {}
  }

  // ---- EDIT BUTTONS ----
  function bindEditButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('#pcp-edit-btn, #pcp-edit-overlay-btn');
      if (!btn) return;

      const section = btn.closest('.pcp-section');
      if (!section) return;
      const handle = section.dataset.productHandle;

      // Read photo count / layout from the button that was clicked (set from metafield in Liquid)
      const slotsSrc = document.getElementById('pcp-edit-btn') || btn;
      const photoSlots    = slotsSrc.getAttribute('data-photo-slots')    || '1';
      const photoLayout   = slotsSrc.getAttribute('data-photo-layout')   || 'single';
      const slotGeometry  = slotsSrc.getAttribute('data-slot-geometry')  || '';
      const templateImage = slotsSrc.getAttribute('data-template-image') || '';

      const trigger = document.createElement('button');
      trigger.setAttribute('data-open-photo-editor', '');
      trigger.setAttribute('data-product-handle', handle);
      trigger.setAttribute('data-product-url', window.location.pathname);
      trigger.setAttribute('data-frame-type', section.dataset.defaultFrameType || 'simple');
      trigger.setAttribute('data-photo-slots',   photoSlots);
      trigger.setAttribute('data-photo-layout',  photoLayout);
      trigger.setAttribute('data-slot-geometry', slotGeometry);
      trigger.setAttribute('data-template-image', templateImage);
      trigger.style.display = 'none';
      document.body.appendChild(trigger);
      trigger.click();
      document.body.removeChild(trigger);
    });
  }

  // ---- TABS ----
  function bindTabs() {
    document.addEventListener('click', (e) => {
      const tab = e.target.closest('.pcp-tabs__tab');
      if (!tab) return;

      const target = tab.dataset.tabTarget;
      const container = tab.closest('.pcp-tabs');
      if (!target || !container) return;

      container.querySelectorAll('.pcp-tabs__tab').forEach((t) => t.classList.remove('pcp-tabs__tab--active'));
      container.querySelectorAll('.pcp-tabs__panel').forEach((p) => p.classList.remove('pcp-tabs__panel--active'));

      tab.classList.add('pcp-tabs__tab--active');
      const panel = document.getElementById(target);
      if (panel) panel.classList.add('pcp-tabs__panel--active');
    });
  }

  // ---- FORM SUBMIT (uses theme's cart-container.add()) ----
  function bindFormSubmit() {
    const form = $('#pcp-product-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitter = e.submitter;
      const isBuyNow = submitter && submitter.name === 'buy_now';

      const variantId = $('#pcp-variant-id')?.value;
      if (!variantId) return;

      const btn = isBuyNow ? $('#pcp-buy-now') : $('#pcp-add-to-cart');
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

      // Build properties from customization
      const properties = {};
      let customizationData = null;

      if (productHandle) {
        try {
          const saved = localStorage.getItem(STORAGE_KEY + productHandle);
          if (saved) customizationData = JSON.parse(saved);
        } catch (err) {}
      }

      if (customizationData && customizationData.thumbnail) {
        properties['Customized Design'] = 'Yes';
        properties['Frame Style'] = customizationData.frameType || 'simple';
        properties['Frame Color'] = customizationData.borderColor || '#000000';
      }

      const cartData = {
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: properties,
      };

      try {
        // Use theme's cart-container.add() method
        const cartContainer = document.querySelector('cart-container');
        if (cartContainer && typeof cartContainer.add === 'function') {
          await cartContainer.add(cartData);
        } else {
          // Fallback: direct fetch
          const response = await fetch((window.Shopify?.routes?.cart_add_url || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cartData),
          });
          if (!response.ok) throw new Error('Cart add failed');
        }

        if (isBuyNow) {
          window.location.href = '/checkout';
          return;
        }

        // Cart image will be injected by kt.cart.reloaded listener
        if (btn) { btn.disabled = false; btn.textContent = 'Added!'; }
        setTimeout(() => {
          if (btn) btn.textContent = originalText;
        }, 2000);
      } catch (err) {
        console.warn('PCP: Cart error', err);
        if (btn) { btn.disabled = false; btn.textContent = 'Error - Try again'; }
        setTimeout(() => {
          if (btn) btn.textContent = originalText;
        }, 2000);
      }
    });
  }

  // ---- CART IMAGE INJECTION ----
  // Listen for kt.cart.reloaded (fired by Cart class after reloadCartElements)
  // Inject customized thumbnail into cart line items
  function listenCartReload() {
    window.addEventListener('kt.cart.reloaded', function () {
      setTimeout(injectCartImages, 300);
    });
  }

  function injectCartImages() {
    if (!productHandle) return;
    try {
      const saved = localStorage.getItem(STORAGE_KEY + productHandle);
      if (!saved) return;
      const data = JSON.parse(saved);
      if (!data.thumbnail) return;

      // Find all cart items with "Customized Design" in their properties
      var cartItems = document.querySelectorAll('.cart-item, .line-item');
      cartItems.forEach(function (item) {
        var propsText = item.textContent || '';
        if (!propsText.includes('Customized Design')) return;
        if (item.querySelector('.pcp-cart-thumb')) return; // already injected

        // Find the image column (first img in the item)
        var existingImg = item.querySelector('img');
        if (existingImg) {
          var wrapper = existingImg.closest('a') || existingImg.parentElement;
          if (wrapper) {
            var thumb = document.createElement('img');
            thumb.src = data.thumbnail;
            thumb.className = 'pcp-cart-thumb';
            thumb.alt = 'Your customized design';
            thumb.style.cssText = 'width:100%;height:auto;border-radius:4px;margin-top:6px;border:1px solid #eee;';
            wrapper.parentElement.appendChild(thumb);
          }
        }
      });
    } catch (err) {}
  }

  // ---- SIZE COMPARISON ----
  function showSizeComparison(oldSize, newSize) {
    const indicator = $('#pcp-size-compare');
    if (!indicator) return;

    const oldParts = oldSize.split('x');
    const newParts = newSize.split('x');
    const oldW = parseFloat(oldParts[0]);
    const oldH = parseFloat(oldParts[1]);
    const newW = parseFloat(newParts[0]);
    const newH = parseFloat(newParts[1]);

    const oldArea = oldW * oldH;
    const newArea = newW * newH;
    const pctChange = Math.round(((newArea - oldArea) / oldArea) * 100);

    let label = '';
    if (pctChange > 0) label = newW + 'x' + newH + '" \u2191 ' + pctChange + '% larger';
    else if (pctChange < 0) label = newW + 'x' + newH + '" \u2193 ' + Math.abs(pctChange) + '% smaller';
    else return;

    indicator.textContent = label;
    indicator.classList.add('pcp-size-compare--show');
    setTimeout(() => indicator.classList.remove('pcp-size-compare--show'), 2500);
  }

  // ---- FORMAT MONEY ----
  function formatMoney(cents) {
    const fmt = window.Shopify?.money_format || '\u20b9{{amount}}';
    let amount;
    if (typeof cents === 'number' && cents > 100) {
      amount = (cents / 100).toFixed(2);
    } else {
      amount = parseFloat(cents).toFixed(2);
    }
    amount = amount.replace(/\.00$/, '');
    return fmt
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(parseFloat(amount)))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  // ---- RESIZE ----
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateMockupOverlay, 200);
  });

  // ---- INIT ----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
